import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import BodyText from './BodyText';
import DashboardTable from './DashboardTable';
import TitleText from './TitleText';
import FlightDealRow from './FlightDealRow';
const tableHeaders = [
	'Travel Date',
	'Sector',
	'Logo',
	'Flight No',
	'Dept. Time',
	'Arr. Time',
	'DEAL Code',
];

const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,
		color: '#8C8C8C',
		// padding: 3,
		fontSize: 16,
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);
const FlightDealTable = () => {
	return (
		<>
			<Grid container spacing={2} style={{ marginTop: 20 }}>
				<Grid item xs={12}>
					<TableContainer style={{ marginTop: 15 }}>
						<Table>
							<TableHead>
								<TableRow>
									{tableHeaders.map((title, index) => (
										<StyledTableCell key={title}>{title}</StyledTableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i, index) => {
									// return <DashboardTable2 rowIndex={index} />;
									return <FlightDealRow rowIndex={index} />;
								})}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</>
	);
};

export default FlightDealTable;
